module.exports = __webpack_public_path__ + "static/media/image2.7d52ff71.webp";